import { intersectionObserverMixin } from '@/helpers/intersectionObserverMixin'
let loading = false
const queue = []

export const youtubeMixin = {
    mixins: [intersectionObserverMixin],
    data() {
        return {
            videoPlayer: null,
            instanceId: this.video.id,
        }
    },
    mounted() {
        this.observeOnce(this.$refs.videoEl, this.loadVideo)
    },
    beforeDestroy() {
        this.$uiEvents.$off('videoStarted', this.pauseSelf)
    },
    methods: {
        pauseSelf(id) {
            // don't pause if the triggering video was this video
            if (id === this.instanceId) return
            this.videoPlayer.pauseVideo()
        },
        async loadVideo() {
            this.instanceId = this.instanceId + Math.trunc(Math.random() * 100000)
            await getYouTube()
            this.videoPlayer = new window.YT.Player(this.instanceId, {
                videoId: this.video.id,
                origin: window.location.origin,
                playerVars: {
                    autoplay: this.autoPlay ? 1 : 0,
                    rel: 0,
                },
                events: {
                    onStateChange: (e) =>
                        e.data === 1 && this.$uiEvents.$emit('videoStarted', this.instanceId),
                },
            })
            this.$uiEvents.$on('videoStarted', this.pauseSelf)
        },
    },
}

function getYouTube() {
    return new Promise((resolve, reject) => {
        if (window.YT && window.YT.Player) return resolve()
        queue.push(resolve)
        if (loading) return
        const script = document.createElement('script')
        script.src = 'https://www.youtube.com/iframe_api'
        script.onload = () =>
            (window.onYouTubeIframeAPIReady = () => queue.forEach((resolve) => resolve()))
        loading = true
        document.head.appendChild(script)
    })
}
